module.exports = __webpack_public_path__ + "assets/icons/launch-logo.119125f122f42eeee9cd25f100de0b66.svg";